import React from "react";

const ErrorText = ({ children }) => {
  return <div className="mt-1 text-sm text-red-500">{children}</div>;
};

export default ErrorText;
